import { CLOSE_NOTIFICATION, NEW_NOTIFICATION, REMOVE_NOTIFICATION } from './types/NotificationTypes';
import {
  ERROR, INFO, SUCCESS, WARNING,
} from '../../NotificationTypes';
import NotificationModel from '../../models/NotificationModel';

export const newInfoNotification = (text, duration = undefined) => ({
  type: NEW_NOTIFICATION,
  payload: {
    ...new NotificationModel()
      .setType(INFO)
      .setText(text)
      .setDuration(duration),
  },
});

export const newWarningNotification = (text, duration = undefined) => ({
  type: NEW_NOTIFICATION,
  payload:
    {
      ...new NotificationModel()
        .setType(WARNING)
        .setText(text)
        .setDuration(duration),
    },
});

export const newErrorNotification = (text, duration = undefined) => ({
  type: NEW_NOTIFICATION,
  payload: {
    ...new NotificationModel()
      .setType(ERROR)
      .setText(text)
      .setDuration(duration),
  },
});

export const newSuccessNotification = (text, duration = undefined) => ({
  type: NEW_NOTIFICATION,
  payload: {
    ...new NotificationModel()
      .setType(SUCCESS)
      .setText(text)
      .setDuration(duration),
  },
});

export const startClosingNotification = ({ id }) => ({
  type: CLOSE_NOTIFICATION,
  payload: {
    id,
  },
});

export const removeNotification = ({ id }) => ({
  type: REMOVE_NOTIFICATION,
  payload: {
    id,
  },
});
